export default "__VITE_ASSET__lP2fN5$8__"